






import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BaseLoading extends Vue {
  @Prop({ required: false, default: "" })
  spacing!: "top" | "bottom";

  @Prop({ required: false, default: false })
  ellipsisOnly!: boolean;

  get ellipsisOnlyClass() {
    return this.ellipsisOnly ? "screen-reader-text" : "";
  }
}
